<template>
  <div>
    <v-container fluid grid-list-sm>
      <v-card>
        <v-toolbar v-if="claimPayment.newHeader" dense color="grey lighten-4" flat>
          <v-btn text icon color="green">
            <v-icon @click="doCancel">mdi-keyboard-backspace</v-icon>
          </v-btn>
          <v-icon>mdi-plus</v-icon>
          <v-toolbar-title>Create New Payment</v-toolbar-title>
          <v-spacer></v-spacer>
        </v-toolbar>
        <v-toolbar v-if="!claimPayment.newHeader" dense color="grey lighten-4" flat>
          <v-btn text icon color="green">
            <v-icon @click="doCancel">mdi-keyboard-backspace</v-icon>
          </v-btn>
          <v-icon>mdi-pencil</v-icon>
          <v-toolbar-title>Payment</v-toolbar-title>
        </v-toolbar>
        <v-card>
          <v-card-text>
            <v-container fluid grid-list-sm>
              <v-layout row wrap>
                <v-flex sm4 xs12>
                  <cal-picker
                    v-model="claimPayHeader.tranDate"
                    :label="labels.tranDate"
                    :min="parseISO(tranDateRange.effDate)"
                    :max="parseISO(tranDateRange.expDate)"
                    v-validate="tranDateValidation"
                    :data-vv-as="labels.tranDate"
                    data-vv-name="tranDate"
                    :error-messages="errors.collect('tranDate')"
                  ></cal-picker>
                </v-flex>
                <v-flex sm4 xs12 v-if="claimPayHeader.clmClsd === false">
                  <v-subheader class="queryLabel">{{ labels.cseStat }}</v-subheader>
                  <div class="subheading">{{ getItemValue(claimPayHeader.cseStat, clmStatCause).label }}</div>
                </v-flex>
                <v-flex sm4 xs12 v-else>
                  <v-autocomplete
                    v-model="claimPayHeader.cseStat"
                    :items="clmStatCause"
                    :label="labels.cseStat"
                    item-text="label"
                    item-value="value"
                    data-vv-name="cseStat"
                    :data-vv-as="labels.cseStat"
                    :error-messages="errors.collect('cseStat')"
                    v-validate="'required'"
                    clearable
                  ></v-autocomplete>
                </v-flex>
                <v-flex sm4 xs12 align-end>
                  <v-checkbox
                    v-model="claimPayHeader.clmClsd"
                    :label="labels.clmClsd"
                    :error-messages="errors.collect('clmClsd')"
                    data-vv-name="clmClsd"
                    :data-vv-as="labels.clmClsd"
                    @change="checkClosedClaim()"
                  ></v-checkbox>
                </v-flex>
                <v-flex sm4 xs12>
                  <v-subheader class="queryLabel">{{ labels.branch }}</v-subheader>
                  <div class="subheading">{{ commonInfo.branch + ' - ' + commonInfo.branchDesc }}</div>
                </v-flex>
                <v-flex sm4 xs12>
                  <v-subheader class="queryLabel">{{ labels.fund }}</v-subheader>
                  <div class="subheading">{{ commonInfo.fundDesc }}</div>
                </v-flex>
                <v-flex sm4 xs12>
                  <v-subheader class="queryLabel">{{ labels.dept }}</v-subheader>
                  <div class="subheading">{{ commonInfo.miscCLDept }}</div>
                </v-flex>
                <v-flex sm4 xs12 v-if="claimPayment.newHeader">
                  <v-autocomplete
                    v-model="claimPayHeader.tranType1"
                    :items="tranTypeList1"
                    :label="labels.tranType1"
                    item-text="label"
                    item-value="value"
                    data-vv-name="tranType1"
                    :data-vv-as="labels.tranType1"
                    :error-messages="errors.collect('tranType1')"
                  ></v-autocomplete>
                </v-flex>
                <v-flex sm4 xs12 v-else>
                  <v-subheader class="queryLabel">{{ labels.tranType1 }}</v-subheader>
                  <div class="subheading">{{ getItemValue(claimPayHeader.tranType1, tranTypeList1).label }}</div>
                </v-flex>
                <v-flex sm4 xs12 v-if="claimPayment.newHeader">
                  <v-layout row wrap>
                    <v-checkbox v-model="autoDocNo" hide-details class="shrink mr-2" @change="genDocNo" :label="labels.autoDocNo" /><span
                      style="width: 20px"
                    />
                    <v-text-field
                      v-model="claimPayHeader.docNo"
                      :label="labels.docNo"
                      :error-messages="errors.collect('docNo')"
                      data-vv-name="docNo"
                      :data-vv-as="labels.docNo"
                      v-validate="'required|entry|max:8'"
                      :disabled="autoDocNo"
                    ></v-text-field>
                  </v-layout>
                </v-flex>
                <v-flex sm4 xs12 v-else>
                  <v-subheader class="queryLabel">{{ labels.docNo }}</v-subheader>
                  <div class="subheading">{{ claimPayHeader.docNo }}</div>
                </v-flex>
                <v-flex xs12 style="padding-top: 20px"> </v-flex>
                <v-flex md4 xs12>
                  <v-radio-group row v-model="claimPayHeader.payTo" label="Pay To / Receive From" @change="payToChanged">
                    <v-radio label="Insured" value="insured" />
                    <v-radio label="Intermediary" value="intermediary" />
                  </v-radio-group>
                </v-flex>
                <v-flex md3 xs12 fill-height>
                  <v-text-field
                    v-model="claimPayHeader.payeeAcctNo"
                    :label="labels.payeeAcctNo"
                    :error-messages="errors.collect('payeeAcctNo')"
                    data-vv-name="payeeAcctNo"
                    :data-vv-as="labels.payeeAcctNo"
                    v-validate="{ validatePayee: [this.payeeValid], max: 8 }"
                    @blur="fetchInsured"
                  >
                    <v-slide-x-reverse-transition mode="out-in" slot="append-outer">
                      <v-icon @click="doShowPayeeHelpList" color="info">mdi-magnify</v-icon>
                    </v-slide-x-reverse-transition>
                  </v-text-field>
                </v-flex>
                <v-flex md1 xs12>
                  <v-text-field
                    disabled
                    v-model="claimPayHeader.acctNoSfx"
                    :label="labels.acctNoSfx"
                    :error-messages="errors.collect('acctNoSfx')"
                    data-vv-name="acctNoSfx"
                    :data-vv-as="labels.acctNoSfx"
                    v-validate="'entry|max:4'"
                  >
                    <!-- <v-slide-x-reverse-transition mode="out-in" slot="append-outer">
                      <v-icon v-if="!claimPayHeader.payInsd" @click="doShowAcctNoSfxHelpList" color="info">mdi-magnify</v-icon>
                    </v-slide-x-reverse-transition> -->
                  </v-text-field>
                </v-flex>
                <v-flex md3 xs12>
                  <div class="queryLabel">&nbsp;</div>
                  <div class="subheading">{{ acctNoSfxDesc }}</div>
                </v-flex>
              </v-layout>
            </v-container>
            <v-container fluid grid-list-sm>
              <v-layout row wrap>
                <v-flex md2 xs12>
                  <v-autocomplete
                    v-validate="{ required: false, max: 60 }"
                    :items="salutationList"
                    clearable
                    v-model="claimPayHeader.titleName"
                    :label="labels.titleName"
                    item-text="label"
                    item-value="value"
                    data-vv-name="titleName"
                    :data-vv-as="labels.titleName"
                    :error-messages="errors.collect('titleName')"
                  ></v-autocomplete>
                </v-flex>
                <v-flex md5 xs12>
                  <v-text-field
                    v-validate="{ required: true, max: 60, entry: true, sanction: sanctionName1Error }"
                    @change="valSanctionClmPayt(claimPayHeader.clmNo,claimPayHeader.name, '', 'sanctionName1Error')"
                    v-model="claimPayHeader.name"
                    :label="labels.name"
                    :error-messages="errors.collect('name')"
                    data-vv-name="name"
                    :data-vv-as="labels.name"
                  ></v-text-field>
                </v-flex>
              </v-layout>
              <v-layout row wrap>
                <v-flex md2 xs12 />
                <v-flex md5 xs12>
                  <v-text-field
                    v-validate="{ required: false, max: 60, entry: true, sanction: sanctionName2Error }"
                    @change="valSanctionClmPayt(claimPayHeader.clmNo,claimPayHeader.name2, '', 'sanctionName2Error')"
                    v-model="claimPayHeader.name2"
                    :label="labels.name2"
                    :error-messages="errors.collect('name2')"
                    data-vv-name="name2"
                    :data-vv-as="labels.name2"
                  ></v-text-field>
                </v-flex>
              </v-layout>
              <v-layout row wrap>
                <v-flex xs12 sm6>
                  <v-text-field
                    v-validate="{ entry: true, max: 60 }"
                    v-model="claimPayHeader.addr1"
                    :label="labels.addr1"
                    :error-messages="errors.collect('addr1')"
                    data-vv-name="addr1"
                    :data-vv-as="labels.addr1"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 sm6>
                  <v-text-field
                    v-validate="{ entry: true, max: 60 }"
                    v-model="claimPayHeader.addr2"
                    :label="labels.addr2"
                    :error-messages="errors.collect('addr2')"
                    data-vv-name="addr2"
                    :data-vv-as="labels.addr2"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 sm6>
                  <v-text-field
                    v-validate="{ entry: true, max: 60 }"
                    v-model="claimPayHeader.addr3"
                    :label="labels.addr3"
                    :error-messages="errors.collect('addr3')"
                    data-vv-name="addr3"
                    :data-vv-as="labels.addr3"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 sm6>
                  <v-text-field
                    v-validate="{ entry: true, max: 60 }"
                    v-model="claimPayHeader.addr4"
                    :label="labels.addr4"
                    :error-messages="errors.collect('addr4')"
                    data-vv-name="addr4"
                    :data-vv-as="labels.addr4"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 sm3>
                  <v-text-field
                    v-validate="{ numeric: true, max: 8 }"
                    v-model="claimPayHeader.postCode"
                    :label="labels.postCode"
                    v-int-mask="{ intScale: 6 }"
                    type="tel"
                    :error-messages="errors.collect('postCode')"
                    data-vv-name="postCode"
                    :data-vv-as="labels.postCode"
                    :loading="appPostalCodeLoading"
                    @change="doFetchAddress"
                  >
                  </v-text-field>
                </v-flex>
              </v-layout>
              <v-layout row wrap>
                <v-flex sm12 xs12>
                  <v-text-field
                    v-model="claimPayHeader.stmtRef"
                    :label="labels.stmtRef"
                    :error-messages="errors.collect('stmtRef')"
                    data-vv-name="stmtRef"
                    :data-vv-as="labels.stmtRef"
                    v-validate="'max:120'"
                  ></v-text-field>
                </v-flex>
              </v-layout>
              <v-layout row wrap>
                <v-flex sm4 xs12>
                  <v-subheader class="queryLabel">{{ labels.inOutGst }}</v-subheader>
                  <div class="queryValue">{{ this.getItemValue(claimPayHeader.inOutGst, this.gstIOs).label }}</div>
                </v-flex>
                <v-flex sm4 xs12>
                  <v-checkbox
                    v-model="claimPayHeader.deemGst"
                    :label="labels.deemGst"
                    :error-messages="errors.collect('deemGst')"
                    data-vv-name="deemGst"
                    :data-vv-as="labels.deemGst"
                    :disabled="!claimParams.permitGST"
                  />
                </v-flex>
                <v-flex sm4 xs12>
                  <!-- <v-autocomplete
                    :disabled="!tranTypeSuffix"
                    clearable
                    @input="adjustBank"
                    v-model="claimPayHeader.bankNo"
                    :items="claimParams.bankList"
                    :label="labels.bankNo"
                    item-text="label"
                    item-value="value"
                    data-vv-name="bankNo"
                    :data-vv-as="labels.bankNo"
                    :error-messages="errors.collect('bankNo')"
                    @click:clear="displayClearBankNoModal()"
                  ></v-autocomplete> -->
                  <v-text-field
                    :disabled="!tranTypeSuffix"
                    v-model="claimPayHeader.bankNo"
                    :label="labels.bankNo"
                    :error-messages="errors.collect('claimPayHeader.bankNo')"
                    data-vv-name="claimPayHeader.bankNo"
                    :data-vv-as="labels.bankNo"
                    @click:clear="displayClearBankNoModal()"
                    readonly
                  >
                    <v-slide-x-reverse-transition mode="out-in" slot="append-outer">
                      <v-icon color="info" @click="showBankHelpList = true">mdi-magnify</v-icon>
                    </v-slide-x-reverse-transition>
                  </v-text-field>
                </v-flex>
                <v-flex sm4 xs12>
                  <v-autocomplete
                    :disabled="!tranTypeSuffix"
                    clearable
                    v-model="claimPayHeader.payChqNo"
                    :items="paymentMethods"
                    :label="labels.payChqNo"
                    item-text="label"
                    item-value="value"
                    data-vv-name="payChqNo"
                    :data-vv-as="labels.payChqNo"
                    :error-messages="errors.collect('payChqNo')"
                  ></v-autocomplete>
                </v-flex>
                <v-flex sm4 xs12>
                  <v-text-field
                    :disabled="!tranTypeSuffix"
                    v-validate="{ required: false, max: 10, entry: true }"
                    v-model="claimPayHeader.cheque"
                    :label="labels.cheque"
                    :error-messages="errors.collect('cheque')"
                    data-vv-name="cheque"
                    :data-vv-as="labels.cheque"
                  ></v-text-field>
                </v-flex>
                <v-flex sm4 xs12>
                  <v-autocomplete
                    clearable
                    v-model="claimPayHeader.prtClmPv"
                    :items="prtClmPVList"
                    :label="labels.prtClmPv"
                    item-text="label"
                    item-value="value"
                    data-vv-name="prtClmPv"
                    :data-vv-as="labels.prtClmPv"
                    :error-messages="errors.collect('prtClmPv')"
                  ></v-autocomplete>
                </v-flex>
                <v-flex sm4 xs12>
                  <v-checkbox
                    v-model="claimPayHeader.prtCseLoss"
                    :label="labels.prtCseLoss"
                    :error-messages="errors.collect('prtCseLoss')"
                    data-vv-name="prtCseLoss"
                    :data-vv-as="labels.prtCseLoss"
                  ></v-checkbox>
                </v-flex>
                <v-flex sm4 xs12>
                  <v-checkbox
                    v-model="claimPayHeader.prtClmtName"
                    :label="labels.prtClmtName"
                    :error-messages="errors.collect('prtClmtName')"
                    data-vv-name="prtClmtName"
                    :data-vv-as="labels.prtClmtName"
                  ></v-checkbox>
                </v-flex>
                <v-flex sm4 xs12>
                  <v-checkbox
                    v-model="claimPayHeader.prtLossDesc"
                    :label="labels.prtLossDesc"
                    :error-messages="errors.collect('prtLossDesc')"
                    data-vv-name="prtLossDesc"
                    :data-vv-as="labels.prtLossDesc"
                  ></v-checkbox>
                </v-flex>
              </v-layout>
            </v-container>
            <v-expansion-panels v-model="panels">
              <v-expansion-panel>
                <v-expansion-panel-header>
                  <div><v-icon>mdi-format-list-bulleted</v-icon><span class="headerTitle">Payment Details</span></div>
                </v-expansion-panel-header>
                <template v-if="this.claimPays">
                  <v-expansion-panel-content v-for="(claimPay, index) in this.claimPays" :key="index" :class="claimPay.hClass">
                    <slot name="header">
                      {{ claimPay.clmNo }} / {{ claimPay.clmtNo }} - {{ getClaimantName(claimPay.clmtNo) }} / Item {{ claimPay.clmItem }} /
                      {{ claimPay.clmResCat }} - {{ claimPay.clmResCatDesc }}
                    </slot>
                    <v-card>
                      <v-card-text :key="claimPay.clmResCat">
                        <v-container fluid grid-list-xs>
                          <v-layout row wrap>
                            <v-flex sm3 xs12 v-if="claimPay.readonly || moreThanOneClmPayt">
                              <v-subheader class="queryLabel">{{ labels.settCode }}</v-subheader>
                              <div class="subheading">{{ getItemValue(claimPay.settCode, settCodeList).label }}</div>
                            </v-flex>
                            <v-flex sm3 xs12 v-else>
                              <v-autocomplete
                                clearable
                                v-model="claimPay.settCode"
                                :items="settCodeList"
                                :label="labels.settCode"
                                item-text="label"
                                item-value="value"
                                :data-vv-name="'settCode' + claimPay.clmResCat"
                                :data-vv-as="labels.settCode"
                                :error-messages="errors.collect('settCode' + claimPay.clmResCat)"
                              ></v-autocomplete>
                            </v-flex>
                            <v-flex sm3 xs12 v-if="claimPay.readonly">
                              <v-subheader class="queryLabel">{{ labels.rcvrPi }}</v-subheader>
                              <div class="subheading">{{ claimPay.rcvrPi ? 'Yes' : 'No' }}</div>
                            </v-flex>
                            <v-flex sm3 xs12 v-else>
                              <v-checkbox
                                :disabled="tranTypePI"
                                v-model="claimPay.rcvrPi"
                                :label="labels.rcvrPi"
                                :error-messages="errors.collect('rcvrPi' + claimPay.clmResCat)"
                                :data-vv-name="'rcvrPi' + claimPay.clmResCat"
                                :data-vv-as="labels.rcvrPi"
                              ></v-checkbox>
                            </v-flex>
                            <v-flex sm3 xs12 v-if="claimPay.readonly">
                              <v-subheader class="queryLabel">{{ labels.isSuppGstreg }}</v-subheader>
                              <div class="subheading">{{ claimPay.isSuppGstreg ? 'Yes' : 'No' }}</div>
                            </v-flex>
                            <v-flex sm3 xs12 v-else>
                              <v-checkbox
                                v-model="claimPay.isSuppGstreg"
                                :label="labels.isSuppGstreg"
                                :error-messages="errors.collect('isSuppGstreg' + claimPay.clmResCat)"
                                :data-vv-name="'isSuppGstreg' + claimPay.clmResCat"
                                :data-vv-as="labels.isSuppGstreg"
                              ></v-checkbox>
                            </v-flex>
                            <v-flex sm3 xs12 v-if="claimPay.readonly">
                              <v-subheader class="queryLabel">{{ labels.theirTaxInv }}</v-subheader>
                              <div class="subheading">{{ claimPay.theirTaxInv }}</div>
                            </v-flex>
                            <v-flex sm3 xs12 v-else>
                              <v-text-field
                                v-model="claimPay.theirTaxInv"
                                :label="labels.theirTaxInv"
                                :error-messages="errors.collect('theirTaxInv' + claimPay.clmResCat)"
                                :data-vv-name="'theirTaxInv' + claimPay.clmResCat"
                                :data-vv-as="labels.theirTaxInv"
                              ></v-text-field>
                            </v-flex>
                            <v-flex sm3 xs12 v-if="claimPay.readonly || moreThanOneClmPayt">
                              <v-subheader class="queryLabel">{{ labels.dvInvDate }}</v-subheader>
                              <div class="subheading">{{ formatDisplayDate(claimPay.dvInvDate) }}</div>
                            </v-flex>
                            <v-flex sm3 xs12 v-else>
                              <cal-picker
                                v-validate="{ required: true }"
                                v-model="claimPay.dvInvDate"
                                :error-messages="errors.collect('dvInvDate' + claimPay.clmResCat)"
                                :label="labels.dvInvDate"
                                :data-vv-as="labels.dvInvDate"
                                :data-vv-name="'dvInvDate' + claimPay.clmResCat"
                              ></cal-picker>
                            </v-flex>
                            <v-flex sm3 xs12 v-if="claimPay.readonly">
                              <v-subheader class="queryLabel">{{ labels.clmPaytType }}</v-subheader>
                              <div class="subheading">{{ getItemValue(claimPay.clmPaytType, paymentTypes).label }}</div>
                            </v-flex>
                            <v-flex sm3 xs12 v-else>
                              <v-autocomplete
                                v-validate="{ required: true }"
                                v-model="claimPay.clmPaytType"
                                :items="paymentTypes"
                                :label="labels.clmPaytType"
                                item-text="label"
                                item-value="value"
                                :data-vv-name="'clmPaytType' + claimPay.clmResCat"
                                :data-vv-as="labels.clmPaytType"
                                :error-messages="errors.collect('clmPaytType' + claimPay.clmResCat)"
                              ></v-autocomplete>
                            </v-flex>
                            <v-flex sm3 xs12 v-if="claimPay.readonly">
                              <v-subheader class="queryLabel">{{ labels.paytDet }}</v-subheader>
                              <div class="subheading">{{ claimPay.paytDet }}</div>
                            </v-flex>
                            <v-flex sm3 xs12 v-else>
                              <v-text-field
                                v-validate="{ required: false, max: 50 }"
                                v-model="claimPay.paytDet"
                                :label="labels.paytDet"
                                :error-messages="errors.collect('paytDet')"
                                data-vv-name="paytDet"
                                :data-vv-as="labels.paytDet"
                              ></v-text-field>
                            </v-flex>
                          </v-layout>
                          <v-layout row wrap>
                            <v-flex sm3 xs12 v-if="claimPay.readonly || claimPays.length > 1">
                              <v-subheader class="queryLabel">{{ labels.curr }}</v-subheader>
                              <div class="subheading">{{ getItemValue(claimPay.curr, currencyList).label }}</div>
                            </v-flex>
                            <v-flex sm3 xs12 v-else>
                              <v-autocomplete
                                clearable
                                @input="adjustCurr(claimPay)"
                                v-model="claimPay.curr"
                                :items="currencyList"
                                :label="labels.curr"
                                item-text="label"
                                item-value="value"
                                data-vv-name="curr"
                                :data-vv-as="labels.curr"
                                :error-messages="errors.collect('curr')"
                              ></v-autocomplete>
                            </v-flex>
                            <v-flex sm3 xs12 v-if="claimPay.readonly || moreThanOneClmPayt">
                              <v-subheader class="queryLabel">{{ labels.exRate }}</v-subheader>
                              <div class="subheading">{{ formatDisplayNumber(claimPay.exRate, 6) }}</div>
                            </v-flex>
                            <v-flex sm3 xs12 v-else>
                              <v-text-field
                                @blur="recalculate()"
                                v-validate="{ required: true }"
                                v-num-mask="{ negative: false, intScale: 5, decScale: 7 }"
                                v-model="claimPay.exRate"
                                :label="labels.exRate"
                                :error-messages="errors.collect('exRate' + claimPay.clmResCat)"
                                :data-vv-name="'exRate' + claimPay.clmResCat"
                                :data-vv-as="labels.exRate"
                              ></v-text-field>
                            </v-flex>
                            <v-flex sm3 xs12 v-if="claimPay.readonly || moreThanOneClmPayt">
                              <v-subheader class="queryLabel">{{ labels.riRcvyCurr }}</v-subheader>
                              <div class="subheading">{{ getItemValue(claimPayHeader.riRcvyCurr, currencyList).label }}</div>
                            </v-flex>
                            <v-flex sm3 xs12 v-else>
                              <v-autocomplete
                                :items="currencyList"
                                v-model="claimPayHeader.riRcvyCurr"
                                :label="labels.riRcvyCurr"
                                item-text="label"
                                item-value="value"
                                data-vv-name="claimPayHeader.riRcvyCurr"
                                :data-vv-as="labels.riRcvyCurr"
                                v-validate="doValidateRiRcvyCurr"
                                :error-messages="errors.collect('claimPayHeader.riRcvyCurr')"
                              />
                            </v-flex>
                          </v-layout>
                          <v-layout row wrap>
                            <v-flex lg3 md3 xs6 v-if="!claimPayHeader.deemGst && !claimPay.readonly">
                              <v-text-field
                                @blur="
                                  claimPay.paytAmtTax = claimPay.paytAmt
                                  recalculate()
                                "
                                v-validate="paymentValidation"
                                v-num-mask="{ negative: true, intScale: 14, decScale: 2 }"
                                v-model="claimPay.paytAmt"
                                :label="labels.paytAmt"
                                :error-messages="errors.collect('paytAmt' + claimPay.clmResCat)"
                                :data-vv-name="'paytAmt' + claimPay.clmResCat"
                                :data-vv-as="labels.paytAmt"
                              ></v-text-field>
                            </v-flex>
                            <v-flex lg3 md3 xs6 v-else>
                              <v-subheader class="queryLabel">{{ labels.paytAmt }}</v-subheader>
                              <div class="subheading">{{ formatDisplayNumber(claimPay.paytAmt, 2) }}</div>
                            </v-flex>
                            <v-flex lg3 md3 xs6>
                              <v-subheader class="queryLabel">{{ labels.paytAmtLoc }}</v-subheader>
                              <div class="subheading">{{ formatDisplayNumber(claimPay.paytAmtLoc, 2) }}</div>
                            </v-flex>
                            <v-flex sm6 xs12> </v-flex>
                            <v-flex lg3 md3 xs6 v-if="!claimPayHeader.deemGst && !claimPay.readonly">
                              <v-text-field
                                @blur="recalculate()"
                                v-validate="{ validPaytAmtTax: claimPay.paytAmt }"
                                v-num-mask="{ negative: true, intScale: 14, decScale: 2 }"
                                v-model="claimPay.paytAmtTax"
                                :label="labels.paytAmtTax"
                                :error-messages="errors.collect('paytAmtTax' + claimPay.clmResCat)"
                                :data-vv-name="'paytAmtTax' + claimPay.clmResCat"
                                :data-vv-as="labels.paytAmtTax"
                              />
                            </v-flex>
                            <v-flex lg3 md3 xs6 v-else>
                              <v-subheader class="queryLabel">{{ labels.paytAmtTax }}</v-subheader>
                              <div class="subheading">{{ formatDisplayNumber(claimPay.paytAmtTax, 2) }}</div>
                            </v-flex>
                            <v-flex lg3 md3 xs6>
                              <v-subheader class="queryLabel">{{ labels.paytAmtTaxLoc }}</v-subheader>
                              <div class="subheading">{{ formatDisplayNumber(claimPay.paytAmtTaxLoc, 2) }}</div>
                            </v-flex>
                            <v-flex sm6 xs12> </v-flex>
                            <v-flex lg3 md3 xs6 v-if="claimPay.readonly || moreThanOneClmPayt">
                              <v-subheader class="queryLabel">{{ labels.gstStat }}</v-subheader>
                              <div class="subheading">{{ getItemValue(claimPay.gstStat, gstRates).label }}</div>
                            </v-flex>
                            <v-flex lg3 md3 xs6 v-else>
                              <v-autocomplete
                                @input="recalculate(getItemValue(claimPay.gstStat, gstRates).secondaryValue)"
                                clearable
                                v-model="claimPay.gstStat"
                                :items="gstRates"
                                :label="labels.gstStat"
                                item-text="label"
                                item-value="value"
                                :data-vv-name="'gstStat' + claimPay.clmResCat"
                                :data-vv-as="labels.gstStat"
                                v-validate="{ required: true }"
                                :error-messages="errors.collect('gstStat' + claimPay.clmResCat)"
                              ></v-autocomplete>
                            </v-flex>
                            <v-flex lg1 md1 xs6>
                              <v-subheader class="queryLabel">{{ labels.gstRate }}</v-subheader>
                              <div class="subheading">{{ formatDisplayNumber(claimPay.gstRate, 2) }}</div>
                            </v-flex>
                            <v-flex lg3 md1 xs6 v-if="checkClmPayt">
                              <div class="subheading">{{ claimPay.gstInfo }}</div>
                            </v-flex>
                            <v-flex lg3 md3 xs6 v-else>
                              <v-autocomplete
                                @input="recalculate(getItemRate(claimPay.gstRate, gstRates2).secondaryValue)"
                                :disabled="claimPay.gstStat == undefined"
                                v-model="claimPay.gstRate"
                                :items="gstRates2"
                                item-text="label"
                                item-value="rate"
                                :data-vv-name="'gstRate' + claimPay.clmResCat"
                                :data-vv-as="labels.gstRate"
                                v-validate="{ required: true }"
                                :error-messages="errors.collect('gstRate' + claimPay.clmResCat)"
                              ></v-autocomplete>
                            </v-flex>
                            <v-flex sm5 xs12> </v-flex>
                            <v-flex lg3 md3 xs6>
                              <v-subheader class="queryLabel">{{ labels.gstAmt }}</v-subheader>
                              <div class="subheading">{{ formatDisplayNumber(claimPay.gstAmt, 2) }}</div>
                            </v-flex>
                            <v-flex lg3 md3 xs6>
                              <v-subheader class="queryLabel">{{ labels.gstAmtLoc }}</v-subheader>
                              <div class="subheading">{{ formatDisplayNumber(claimPay.gstAmtLoc, 2) }}</div>
                            </v-flex>
                            <v-flex sm6 xs12> </v-flex>
                            <v-flex v-if="claimPay.firstNetAmt">
                            <v-flex lg10 md3 xs6 v-if="claimPayHeader.deemGst">
                              <v-text-field
                                @blur="recalculate()"
                                v-validate="paymentValidation"
                                v-num-mask="{ negative: true, intScale: 14, decScale: 2 }"
                                v-model="claimPay.netAmt"
                                :label="labels.netAmt"
                                :error-messages="errors.collect('netAmt' + claimPay.clmResCat)"
                                :data-vv-name="'netAmt' + claimPay.clmResCat"
                                :data-vv-as="labels.netAmt"
                              ></v-text-field>
                            </v-flex>
                            <v-flex lg3 md3 xs6 v-else>
                              <v-subheader class="queryLabel">{{ labels.netAmt }}</v-subheader>
                              <div class="subheading">{{ formatDisplayNumber(claimPay.netAmt, 2) }}</div>
                            </v-flex>
                            </v-flex>
                            <v-flex lg3 md3 xs6 v-else>
                              <v-subheader class="queryLabel">{{ labels.netAmt }}</v-subheader>
                              <div class="subheading">{{ formatDisplayNumber(claimPay.netAmt, 2) }}</div>
                            </v-flex>
                            <v-flex lg3 md3 xs6>
                              <v-subheader class="queryLabel">{{ labels.netAmtLoc }}</v-subheader>
                              <div class="subheading">{{ formatDisplayNumber(claimPay.netAmtLoc, 2) }}</div>
                            </v-flex>
                            <v-flex sm6 xs12>
                              <v-subheader class="queryLabel">{{ labels.amtRes }}</v-subheader>
                              <div class="subheading">{{ formatDisplayNumber(claimPay.paytAmtRes, 2) }}</div>
                            </v-flex>
                            <v-flex sm6 xs12> </v-flex>
                            <v-flex lg12 md12 xs36>
                              <!-- <div class="subheading">{{getItemValue(bankChrgResCurr, currencyList).label}}</div> -->
                              <v-flex lg3 md3 xs12>
                                <v-autocomplete
                                  :items="currencyList"
                                  v-model="bankChrgResCurr"
                                  :label="labels.bankAcctCurr"
                                  item-text="label"
                                  item-value="value"
                                  data-vv-name="bankChrgResCurr"
                                  :data-vv-as="labels.bankAcctCurr"
                                  :disabled="true"
                                />
                              </v-flex>
                            </v-flex>
                            <v-flex lg3 md3 xs12 v-if="claimPay.readonly">
                              <v-subheader class="queryLabel">{{ labels.bankChrg }}</v-subheader>
                              <div class="subheading">{{ formatDisplayNumber(claimPay.bankChrg, 2) }}</div>
                            </v-flex>
                            <v-flex lg3 md3 xs12 v-else>
                              <v-text-field
                                :disabled="!tranTypeSuffix"
                                v-num-mask="{ negative: true, intScale: 14, decScale: 2 }"
                                v-model="claimPay.bankChrg"
                                :label="labels.bankChrg"
                                :error-messages="errors.collect('bankChrg' + claimPay.clmResCat)"
                                :data-vv-name="'bankChrg' + claimPay.clmResCat"
                                :data-vv-as="labels.bankChrg"
                                v-validate="bankChrgValidation"
                                @input="recalculate()"
                              />
                            </v-flex>
                            <v-flex lg3 md3 xs12>
                              <v-subheader class="queryLabel">{{ labels.bankChrgLoc }}</v-subheader>
                              <div class="subheading">{{ formatDisplayNumber(claimPay.bankChrgLoc, 2) }}</div>
                            </v-flex>
                            <v-flex lg3 md3 xs12>
                              <v-subheader class="queryLabel">{{ labels.bankChrgRes }}</v-subheader>
                              <div class="subheading">{{ formatDisplayNumber(claimPay.bankChrgRes, 2) }}</div>
                            </v-flex>
                            <v-flex lg3 md3 xs12> </v-flex>
                            <v-flex lg3 md3 xs12 v-if="claimPay.readonly">
                              <v-subheader class="queryLabel">{{ labels.prtOffSettLtr }}</v-subheader>
                              <div class="subheading">{{ claimPay.prtOffSettLtr ? 'Yes' : 'No' }}</div>
                            </v-flex>
                            <v-flex lg3 md3 xs12 v-else>
                              <v-autocomplete
                                v-model="claimPay.prtOffSettLtr"
                                :items="prtOffSetLtrList"
                                :label="labels.prtOffSettLtr"
                                item-text="label"
                                item-value="value"
                                :data-vv-name="'prtOffSettLtr' + claimPay.prtOffSettLtr"
                                :data-vv-as="labels.prtOffSettLtr"
                                :error-messages="errors.collect('claimPay.prtOffSettLtr' + claimPay.clmResCat)"
                              ></v-autocomplete>
                            </v-flex>
                            <v-flex lg3 md3 xs12 v-if="claimPay.readonly">
                              <v-subheader class="queryLabel">{{ labels.prtClmDv }}</v-subheader>
                              <div class="subheading">{{ claimPay.prtClmDv ? 'Yes' : 'No' }}</div>
                            </v-flex>
                            <v-flex lg3 md3 xs12 v-else>
                              <v-autocomplete
                                v-model="claimPay.prtClmDv"
                                :items="prtClmPVList"
                                :label="labels.prtClmDv"
                                item-text="label"
                                item-value="value"
                                :data-vv-name="'prtClmDv' + claimPay.clmResCat"
                                :data-vv-as="labels.prtClmDv"
                                :error-messages="errors.collect('claimPay.prtClmDv' + claimPay.clmResCat)"
                              ></v-autocomplete>
                            </v-flex>
                          </v-layout>
                        </v-container>
                      </v-card-text>
                    </v-card>
                  </v-expansion-panel-content>
                </template>
              </v-expansion-panel>
            </v-expansion-panels>
            <v-card>
              <v-card-text>
                <v-layout row wrap>
                  <v-flex lg3 md3 xs6>
                    <v-subheader class="queryLabel">{{ labels.totAmt }}</v-subheader>
                    <div class="subheading">{{ formatDisplayNumber(totAmt, 2) }}</div>
                  </v-flex>
                  <v-flex lg3 md3 xs6>
                    <v-subheader class="queryLabel">{{ labels.totAmtLoc }}</v-subheader>
                    <div class="subheading">{{ formatDisplayNumber(totAmtLoc, 2) }}</div>
                  </v-flex>
                  <v-flex sm6 xs12> </v-flex>
                  <v-flex lg3 md3 xs6>
                    <v-subheader class="queryLabel">{{ labels.totAmtTax }}</v-subheader>
                    <div class="subheading">{{ formatDisplayNumber(totAmtTax, 2) }}</div>
                  </v-flex>
                  <v-flex lg3 md3 xs6>
                    <v-subheader class="queryLabel">{{ labels.totAmtTaxLoc }}</v-subheader>
                    <div class="subheading">{{ formatDisplayNumber(totAmtTaxLoc, 2) }}</div>
                  </v-flex>
                </v-layout>
              </v-card-text>
            </v-card>
          </v-card-text>
          <v-card-actions>
            <v-spacer class="mt-2"></v-spacer>
            <v-btn color="red" dark type="submit" @click.prevent="doCancel">
              <span>Cancel</span>
              <v-icon right dark>mdi-cancel</v-icon>
            </v-btn>
            <v-btn color="primary" type="submit" :loading="submitting" @click.prevent="doPostPayment">
              <span>Save</span>
              <v-icon right>mdi-content-save</v-icon>
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-card>
      <confirm v-model="postCodeDialog" title="Postal Code" info> Key in Postal Code to search your address </confirm>
    </v-container>
    <v-dialog v-model="showInterHelpList" width="900px">
      <intermediary-help-list
        @close="showInterHelpList = false"
        headerInfo="default"
        @assign-intermediary-data="assignInter"
      ></intermediary-help-list>
    </v-dialog>
    <v-dialog v-model="showInsuredHelpList" width="900px">
      <insured-help-list
        :insuredFieldKey="insuredFieldKey"
        @close="showInsuredHelpList = false"
        @assign-insured-info="assignInsured"
      ></insured-help-list>
    </v-dialog>
    <v-dialog v-model="showAcctNoSfxHelpList" width="900px">
      <acct-suf-help-list
        :acctNoSfxApplnInt="this.acctNoSfxApplnInt"
        @close="showAcctNoSfxHelpList = false"
        @assign-acct-suf-info="assignAcctNoSfx"
      ></acct-suf-help-list>
    </v-dialog>
    <!-- BankNo -->
    <v-dialog v-model="showBankHelpList" width="1080px">
      <bank-help-list :branch="commonInfo.branch" :fund="commonInfo.fund" @close="showBankHelpList = false" @assign-bank="doAssign($event)"></bank-help-list>
    </v-dialog>
    <!--LYT Added: 2020-08-27  Sanction Partial Matched Names List -->
    <v-dialog v-model="showSanctionDialog" width="1280px">
      <sanction-partial-match-list :sanctionItems="sanctionPartialMatchItems" @close="showSanctionDialog = false"></sanction-partial-match-list>
    </v-dialog>

    <confirm v-model="showModalAction" @ok="doModalAction"
      >Clearing Bank No will Zerolise the following values : 'Cheque', 'Cheque No', 'Bank Charges', 'Bank Charges Currency', 'Bank Charges', 'Bank
      Charges Local', 'Bank Charges in Reserve Currency'. Confirm to proceed?</confirm
    >
    <confirm v-model="promptAdjResTxt" @cancel="promptAdjResTxt = false" @ok="doCancel" yes-label="OK" :info="false">{{ adjResTxt }}</confirm>
    <warning v-model="promptMsg" :label="errMsg" :showAcceptBtn="isWarning" @ok="acceptInterWarn = true"/>
  </div>
</template>

<script>
import clone from 'clone'
import { ClaimCommonMixin } from '@/mixins/claim/ClaimCommonMixin'
import { formatDisplayNumber, removeFormatNumber } from '@/utils/number'
import { formatDisplayDate } from '@/utils/date'
import { parseISO } from 'date-fns'
import MessageMixin from '@/mixins/message'
import { expandURI } from '@/utils/ajax'
import { isEmptyOrWhiteSpace } from '@/utils/index'
import { CLAIMS_LIFECYCLE } from '@/store/types'
import { commonAjaxMixin } from '@/mixins/common/commonAjaxMixin'
import IntermediaryHelpList from '@/components/core/common/dialog/IntermediaryHelpList'
import InsuredHelpList from '@/components/core/common/dialog/InsuredHelpList'
import AcctSufHelpList from '@/components/core/common/dialog/AcctSufHelpList'
import SanctionPartialMatchList from '@/components/core/common/dialog/SanctionPartialMatchList'
import BankHelpList from '@/components/core/claimManagement/helpList/BankHelpList'
import Confirm from '../../../reusable/global/Confirm.vue'

export default {
  components: {
    IntermediaryHelpList,
    InsuredHelpList,
    AcctSufHelpList,
    SanctionPartialMatchList,
    BankHelpList,
    Confirm
  },
  data() {
    return {
      // Layer controller
      documentLayer: false,
      appPostalCodeLoading: false,
      postCodeDialog: false,
      addrFound: false,
      panels: 0,
      clmClsd: false,
      moreThanOneClmPayt: false,
      showInterHelpList: false,
      showInsuredHelpList: false,
      showAcctNoSfxHelpList: false,
      acctNoSfxApplnInt: '00',
      insuredFieldKey: 'payeeAcctNo',
      payeeValid: false,
      currencyList: [],
      departmentObj: [],
      submitting: false,
      claimPayHeader: {
        clmNo: undefined,
        clmtName: undefined,
        clmtNo: undefined,
        clmItem: undefined,
        fund: undefined,
        clmClsd: false,
        branch: undefined,
        cseStat: undefined,
        tranType1: undefined,
        docNoAE: true,
        docNo: undefined,
        payChqNo: undefined,
        tranDate: undefined,
        rcvrPi: false,
        payTo: undefined,
        payInsd: undefined,
        payeeAcctNo: undefined,
        acctNoSfx: undefined,
        inOutGst: undefined,
        deemGst: false,
        curr: undefined,
        exRate: undefined,
        riRcvyCurr: undefined,
        prtClmPv: undefined,
        prtCseLoss: undefined,
        titleName: undefined,
        prtClmtName: undefined,
        name: undefined,
        name2: undefined,
        prtLossDesc: undefined,
        addr1: undefined,
        addr2: undefined,
        addr3: undefined,
        addr4: undefined,
        postCode: undefined,
        bankNo: undefined,
        cheque: undefined,
        bankAcctCurr: undefined,
        payments: []
      },
      labels: {
        clmtName: 'Claimant Name',
        clmItem: 'Claim Item',
        clmClsd: 'Close Claim',
        branch: 'Branch',
        fund: 'Fund',
        dept: 'Department',
        cseStat: 'Cause of Status',
        tranType1: 'Transaction Type',
        docNoAE: 'Is New Document No. ?',
        autoDocNo: 'Auto Payment No',
        docNo: 'Document No.',
        payChqNo: 'Cheque or GIRO',
        tranDate: 'Transaction Date',
        acctNoSfx: 'Suffix',
        inOutGst: 'GST I/O',
        deemGst: 'Deemed GST',
        curr: 'Currency',
        exRate: 'Exchange Rate',
        riRcvyCurr: 'RI Recovery Currency',
        prtClmPv: 'Print Document',
        prtCseLoss: 'Print Cause of Loss',
        titleName: 'Salutation',
        prtClmtName: 'Print Claimant Name',
        name: 'Name*',
        name2: 'Name2',
        prtLossDesc: 'Print Description of Loss',
        prtOffSettLtr: 'Print Offer Settlement Letter',
        addr1: 'Address',
        addr2: '',
        addr3: '',
        addr4: '',
        postCode: 'Postal Code',
        stmtRef: 'Statement Reference',
        bankNo: 'Bank No.',
        cheque: 'Cheque No.',
        bankAcctCurr: 'Bank Account Currency',
        settCode: 'Settlement Code',
        clmResCat: 'Reserve Category',
        rcvrPi: 'Recovery from P&I',
        payInsd: 'Pay to Insured',
        payeeAcctNo: 'Payee',
        clmPaytType: 'Payment Type',
        paytDet: 'Payment Details',
        isSuppGstreg: 'Is Supplier GST Registered ?',
        theirTaxInv: 'Their Tax Invoice No.',
        dvInvDate: 'DV/Invoice Date',
        pastReversal: undefined,
        paytAmt: 'Claim Payment (excl GST)',
        paytAmtLoc: 'Local Claim Payment (excl GST)',
        paytAmtTax: 'Amount Taxable',
        paytAmtTaxLoc: 'Local Amount Taxable',
        gstStat: 'GST Status',
        gstRate: 'GST Rate',
        gstAmt: 'GST Amount',
        gstAmtLoc: 'Local GST Amount',
        netAmt: 'Net Amount',
        netAmtLoc: 'Local Net Amount',
        bankChrg: 'Bank Charges',
        bankChrgLoc: 'Local Bank Charges',
        prtClmDv: 'Print Discharge Voucher',
        totAmt: 'Total Amount',
        totAmtLoc: 'Local Total Amount',
        amtRes: 'Amount (in Reserve Currency)',
        totAmtTax: 'Total Taxable Amount',
        totAmtTaxLoc: 'Local Total Taxable Amount',
        bankChrgRes: 'Bank Charges (in Reserve Currency)',
        acctNoSfxDesc: '  sss    '
      },
      bankChrgRes: undefined,
      bankChrgResCurr: undefined,
      bankBalance: formatDisplayNumber(0, 2),
      totAmt: 0,
      totAmtLoc: 0,
      totAmtTax: 0,
      totAmtTaxLoc: 0,
      claimPaymentHeader: {},
      claimPays: [],
      gstRates: [],
      gstRates2: [],
      gstIOList: [
        { value: 'I', label: 'I - Input GST' },
        { value: 'O', label: 'O - Output GST' }
      ],
      eventSearch: null,
      autoDocNo: true,
      payeeAcctNoLoading: false,
      prevClmRiRcvyCurr: null,
      selectedCurrency: null,
      showModalAction: false,
      bankChrgEdit: null,
      bankChrgLocChange: null,
      acctNoSfxDesc: undefined,
      selectGstStatDesc: undefined,
      showBankHelpList: false,
      gstRate: 0,
      gstInfo: undefined,
      checkClmPayt: false,
      firstEnterScreen: true,
      authTxt: '',
      promptAdjResTxt: false,
      adjResTxt: "Payment has exceeded user's Limit",
      clmStatCause: []
    }
  },
  watch: {
    'claimPayHeader.tranType1': {
      handler: function(value) {
        switch (value) {
          case 'W': {
            // Init GST config
            // 19/01/22 Modify inOutGst
            this.claimPayHeader.inOutGst = 'O'
            // Init Bank Info
            this.claimPayHeader.bankNo = null
            this.claimPayHeader.bankAcctCurr = null
            this.claimPayHeader.cheque = null
            this.fetchAcctNoSuffixes()
            this.bankChrgEdit = true
            // this.claimPays.map(el => {
            //   el.rcvrPi = false
            //   el.pastReversal = false
            //   el.bankChrg = formatDisplayNumber(0, 2)
            //   el.bankChrgLoc = formatDisplayNumber(0, 2)
            //   el.bankChrgRes = formatDisplayNumber(0, 2)
            // })
            break
          }
          case 'X': {
            // Init GST config
            this.claimPayHeader.inOutGst = 'I'
            // Init Bank Info
            this.claimPayHeader.bankNo = null
            this.claimPayHeader.bankAcctCurr = null
            this.claimPayHeader.cheque = null
            this.fetchAcctNoSuffixes()
            this.bankChrgEdit = true
            // this.claimPays.map(el => {
            //   el.rcvrPi = false
            //   el.pastReversal = false
            //   el.bankChrg = formatDisplayNumber(0, 2)
            //   el.bankChrgLoc = formatDisplayNumber(0, 2)
            //   el.bankChrgRes = formatDisplayNumber(0, 2)
            // })
            break
          }
          case 'Y': {
            // Init GST config
            this.claimPayHeader.inOutGst = 'O'
            this.labels.pastReversal = 'Reversal for Past Payment'
            if (this.bankChrgResCurr === null || this.bankChrgResCurr === '') {
              this.claimPays.map(el => {
                el.rcvrPi = false
                el.pastReversal = false
                el.bankChrg = formatDisplayNumber(0, 2)
                el.bankChrgLoc = formatDisplayNumber(0, 2)
                el.bankChrgRes = formatDisplayNumber(0, 2)
                this.bankChrgEdit = false
              })
            }
            break
          }
          case 'Z': {
            // Init GST config
            this.claimPayHeader.inOutGst = 'I'
            this.labels.pastReversal = 'Reversal for Past Receipt'
            if (this.bankChrgResCurr === null || this.bankChrgResCurr === '') {
              this.claimPays.map(el => {
                el.rcvrPi = false
                el.pastReversal = false
                el.bankChrg = formatDisplayNumber(0, 2)
                el.bankChrgLoc = formatDisplayNumber(0, 2)
                el.bankChrgRes = formatDisplayNumber(0, 2)
                this.bankChrgEdit = false
              })
            }
            break
          }
        }
      }
    },
    'claimPayHeader.bankNo': {
      handler: function(value) {
        if (value == null && value === '') {
          this.claimPayHeader.cheque = null
          this.claimPayHeader.payChqNo = null
          this.claimPayHeader.bankAcctCurr = null
          this.claimPays.map(el => {
            el.bankChrg = formatDisplayNumber(0, 2)
            el.bankChrgLoc = formatDisplayNumber(0, 2)
            el.bankChrgRes = formatDisplayNumber(0, 2)
          })
        }
      }
    }
  },
  computed: {
    claimDetail() {
      return this.$store.state.claims.claimDetail
    },
    tranDate() {
      return this.$store.state.claims.claimDetail.tranDate || new Date()
    },
    selectedClaimant() {
      return this.claimDetail.selectedClaimant || {}
    },
    selectedClmItem() {
      return this.claimDetail.selectedClmItem || {}
    },
    selectedClmResCat() {
      if (this.paymentReserves && this.paymentReserves.length) {
        return this.paymentReserves[0].clmResCat
      }
      return undefined
    },
    selectedClmResCatDesc() {
      if (this.paymentReserves && this.paymentReserves.length) {
        return this.paymentReserves[0].clmResCatDesc
      }
      return undefined
    },
    resCurrList() {
      return this.$store.state.claims.claimParams.resCurrList
    },
    commonInfo() {
      return this.claimDetail.commonInfo
    },
    claimPayment() {
      return this.$store.state.claims.claimPayment
    },
    paymentHeader() {
      return this.$store.state.claims.claimPayment.selectedHeader
    },
    paymentReserves() {
      return this.$store.state.claims.claimPayment.selectedReserves
    },
    reserveList() {
      return this.$store.state.claims.claimParams.reservesList
    },
    tranDateRange() {
      return this.$store.state.claims.claimParams.paymentTranDateRange
    },
    claimParams() {
      return this.$store.state.claims.claimParams
    },
    tranTypePI() {
      if (!isEmptyOrWhiteSpace(this.claimPayHeader.tranType1)) {
        if (this.claimPayHeader.tranType1 === 'Z') {
          return false
        }
      }
      return true
    },
    tranTypeSuffix() {
      if (!isEmptyOrWhiteSpace(this.claimPayHeader.tranType1)) {
        if (this.claimPayHeader.tranType1 === 'Z' || this.claimPayHeader.tranType1 === 'Y') {
          return true
        }
      }
      return false
    },
    tranDateValidation() {
      if (this.tranDateRange.effDate !== null && this.tranDateRange.expDate !== null) {
        return { required: true, from_to_date: this.tranDateRange.effDate, after_to_date: this.tranDateRange.expDate }
      }
      return { required: true }
    },
    bankChrgValidation() {
      if (!this.claimPayHeader.bankNo && this.claimPayment.bankChrg !== 0) {
        return { validateBankChrg: this.claimPayHeader.bankNo }
      }
      return { required: false }
    },
    paymentValidation() {
      if (this.claimPayHeader !== null) {
        return { required: true, not_zero: true }
      }
      return { required: true }
    },
    doValidateRiRcvyCurr() {
      const baseCurr = this.claimParams.baseCurr
      const riRcyCurr = this.claimPayHeader.riRcvyCurr
      let paytCurr = null
      if (this.claimPayHeader.clmPays) {
        if (this.claimPayHeader.clmPays.length !== 0) {
          paytCurr = this.claimPayHeader.clmPays[0].curr
        }
      }
      const bankChrgCurr = this.claimPayment.resCurr
      const curr = this.selectedCurrency
      const paramNames = [baseCurr, riRcyCurr, bankChrgCurr, curr]
      if (paytCurr != null) {
        if (riRcyCurr !== baseCurr && paytCurr !== riRcyCurr) {
          // return { required: true, validatePaytCurr: paramNames, validateBaseCurr: paramNames }
          return { required: true, validateBaseCurr: paramNames }
        } else {
          // 3.4
          this.fetchClmRiRcvy()
          if (this.prevClmRiRcvyCurr !== null && this.prevClmRiRcvyCurr !== '') {
            const params = [this.prevClmRiRcvyCurr, riRcyCurr]
            return { required: true, validateclmRiRcvyCurr: params }
          } else {
            return {}
          }
        }
      } else {
        if (riRcyCurr !== baseCurr) {
          // return { required: true, validatePaytCurr: paramNames, validateBaseCurr: paramNames }
          return { required: true, validateBaseCurr: paramNames }
        } else {
          // 3.4
          this.fetchClmRiRcvy()
          if (this.prevClmRiRcvyCurr !== null && this.prevClmRiRcvyCurr !== '') {
            const params = [this.prevClmRiRcvyCurr, riRcyCurr]
            return { required: true, validateclmRiRcvyCurr: params }
          } else {
            return {}
          }
        }
      }
    }
  },
  methods: {
    formatDisplayDate(date) {
      return formatDisplayDate(date)
    },
    doShowPayeeHelpList() {
      if (this.claimPayHeader.payTo === 'intermediary') {
        this.showInterHelpList = true
      } else if (this.claimPayHeader.payTo === 'insured') {
        this.showInsuredHelpList = true
      }
    },
    assignInter(inter) {
      this.claimPayHeader.payeeAcctNo = inter.inter
      this.claimPayHeader.titleName = inter.titleName
      this.claimPayHeader.name = inter.name
      this.claimPayHeader.name2 = inter.name2
      this.claimPayHeader.addr1 = inter.address1
      this.claimPayHeader.addr2 = inter.address2
      this.claimPayHeader.addr3 = inter.address3
      this.claimPayHeader.addr4 = inter.address4
      this.claimPayHeader.postCode = inter.postalCode
      this.payeeValid = true
    },
    assignInsured(insured) {
      this.claimPayHeader.payeeAcctNo = insured.insdRefNo
      this.claimPayHeader.titleName = insured.titleName
      this.claimPayHeader.name = insured.fullName
      this.claimPayHeader.name2 = insured.name2
      this.claimPayHeader.addr1 = insured.address1
      this.claimPayHeader.addr2 = insured.address2
      this.claimPayHeader.addr3 = insured.address3
      this.claimPayHeader.addr4 = insured.address4
      this.claimPayHeader.postCode = insured.postalCode
      this.payeeValid = true
    },
    doShowAcctNoSfxHelpList() {
      this.showAcctNoSfxHelpList = true
    },
    displayClearBankNoModal() {
      this.showModalAction = true
    },
    assignAcctNoSfx(sfx) {
      this.claimPayHeader.acctNoSfx = sfx.acctNoSfx
      this.acctNoSfxDesc = sfx.description
    },
    doPostPayment() {
      this.submitting = true
      this.$validator.validateAll().then(result => {
        if (result) {
          this.claimPayHeader.fund = this.commonInfo.fund
          this.claimPayHeader.payments = this.claimPays
          this.doSaveClaimPayment().then(saveRes => {
            if (saveRes) {
              this.$store.commit(CLAIMS_LIFECYCLE, 5)
              this.$router.push({ name: 'claimReserve' })
            }
          })
        } else {
          this.submitting = false
          this.promptFieldCheck()
        }
      })
    },
    async doSaveClaimPayment() {
      let result = false
      if (this.claimPayHeader.payTo === 'intermediary') {
        await this.validateIntermediary(this.claimPayHeader.tranDate, this.claimPayHeader.payeeAcctNo)
        if (this.promptMsg === false || this.acceptInterWarn === true) {
          result = await this.doHeaderSave()
        }
      } else {
        result = await this.doHeaderSave()
      }
      return result
    },
    async doHeaderSave() {
      // No mandatory validation here. Commit whatever thats on screen and do neccesary actions before saving
      // Must return true/false
      let result = false
      try {
        if (this.claimPayHeader.bankNo !== undefined && this.claimPayHeader.bankNo !== '' && this.claimPayHeader.bankNo !== null) {
          const bankNoSplit = this.claimPayHeader.bankNo.split(' - ')
          this.claimPayHeader.bankNo = bankNoSplit[0]
        }
        const promptFlag = await this.$store.dispatch('saveClaimPaymentHeader', this.claimPayHeader)
        if (promptFlag) {
          const copyOfPayment = JSON.parse(JSON.stringify(this.claimPayHeader))
          const paymentNotifData = {
            clmNo: copyOfPayment.clmNo,
            clmtNo: copyOfPayment.clmtNo,
            clmItem: copyOfPayment.clmItem,
            branch: copyOfPayment.branch,
            tranType1: copyOfPayment.tranType1,
            fund: copyOfPayment.fund,
            clmResCat: copyOfPayment.payments[0].clmResCat,
            docNo: copyOfPayment.payments[0].docNo
          }
          this.$store.commit('UPDATE_CLM_PEND_EXIST_LIST', {
            promptFlagPay: true,
            paymentOverLimit: paymentNotifData
          })
        }
        this.promptAdjResTxt = promptFlag
        this.firstEnterScreen = false
        await this.$store.dispatch('getMessagesCount')
        result = !promptFlag
        this.submitting = false
      } catch (err) {
        result = false
        this.submitting = false
      }
      return result
    },
    async doCancel() {
      this.back = true
      this.$store.commit(CLAIMS_LIFECYCLE, 5)
      this.$router.push({ name: 'claimPaymentList' })
    },
    parseISO(value) {
      return parseISO(value)
    },
    async init() {
      this.promptAdjResTxt = false
      this.getCommonDataList('clmStatCause')
      if (this.claimPayment.newHeader) {
        this.claimPayHeader.tranType1 = 'Z'
        this.claimPayHeader.payChqNo = 'C'
        this.claimPayHeader.cseStat = ''
        this.claimPayHeader.docNoAE = true
        this.claimPayHeader.tranDate = this.tranDate
        this.claimPayHeader.payInsd = true
        this.claimPayHeader.payTo = 'insured'
        this.claimPayHeader.inOutGst = 'B'
        this.claimPayHeader.branch = this.commonInfo.branch
        this.claimPayHeader.payeeAcctNo = this.commonInfo.insdRefNo
        this.fetchInsured()
        this.claimPayHeader.curr = this.commonInfo.resCurr
        this.claimPayHeader.riRcvyCurr = this.claimPayHeader.curr
        this.claimPayHeader.exRate = formatDisplayNumber(this.getCurrRate(this.claimPayHeader.curr), 6)
        this.claimPayHeader.prtClmPv = 'N'
        this.claimPayHeader.totAmt = 0
        this.claimPayHeader.totAmtLoc = 0
        this.claimPayHeader.totAmtTax = 0
        this.claimPayHeader.totAmtTaxLoc = 0
        this.claimPayHeader.prtClmtName = true
        this.claimPayHeader.prtCseLoss = true
        this.claimPayHeader.prtLossDesc = true
        this.claimPayHeader.curr = this.claimParams.baseCurr
        this.claimPayHeader.exRate = this.claimParams.baseRate
        this.claimPayHeader.acctNoSfx = this.commonInfo.acctNoSfx
      } else {
        this.claimPaymentHeader = clone(this.paymentHeader)
        this.claimPayHeader.tranDate = new Date(this.claimPayHeader.tranDate)
        if (this.paymentHeader.payInsd) {
          this.claimPaymentHeader.payTo = 'insured'
        } else {
          this.claimPaymentHeader.payTo = 'intermediary'
        }

        if (!this.claimPaymentHeader.acctNoSfx) {
          this.claimPayHeader.acctNoSfx = this.commonInfo.acctNoSfx
        }
        this.clmClsd = this.claimPaymentHeader.clmClsd
        this.claimPayHeader = this.claimPaymentHeader
        this.payeeValid = true
        if (this.claimPayHeader.clmPays.length > 0) {
          this.moreThanOneClmPayt = true
        }
      }
      // run param function first load
      this.claimPayHeader.clmNo = this.commonInfo.clmNo
      this.claimPayHeader.clmtName = this.selectedClaimant.clmtName
      this.claimPayHeader.clmtNo = this.selectedClaimant.clmtNo
      this.claimPayHeader.clmItem = this.selectedClmItem.clmItem
      this.claimPayHeader.fund = this.commonInfo.fund
      this.bankChrgResCurr = this.claimPayment.resCurr
      this.selectedCurrency = this.commonInfo.resCurr
      this.fetchPaymentTypes()
      this.fetchGstRates().then(() => {
        this.initClmPayForm()
      })
      this.genDocNo()
      // Zerolise all bank related information if Bank No is null or empty
      if (this.claimPayHeader.bankNo === null || this.claimPayHeader.bankNo === '') {
        this.initBankInfo()
      }
    },
    async initClmPayForm() {
      this.claimPays = []
      const otherClmPays = []
      let relClmPay = null
      let exists = false
      if (this.claimPayHeader.clmPays && this.claimPayHeader.clmPays.length > 0) {
        for (let clmPay of this.claimPayHeader.clmPays) {
          if (
            clmPay.clmNo === this.commonInfo.clmNo &&
            clmPay.clmtNo === this.selectedClaimant.clmtNo &&
            clmPay.clmItem === this.selectedClmItem.clmItem &&
            clmPay.clmResCat === this.selectedClmResCat
          ) {
            clmPay.hClass = 'white'
            clmPay.readonly = false
            relClmPay = clmPay
            this.selectGstStatDesc = clmPay.gstStat + ' - ' + formatDisplayNumber(clmPay.gstRate, 2)
          } else {
            clmPay.readonly = true
            clmPay.hClass = 'grey lighten-4'
            otherClmPays.push(clmPay)
          }
        }
        exists = true
      }
      if (!relClmPay) {
        for (let reserve of this.paymentReserves) {
          const payForm = {
            // Set default
            clmNo: this.commonInfo.clmNo,
            clmtNo: this.selectedClaimant.clmtNo,
            clmItem: this.selectedClmItem.clmItem,
            clmResCat: this.selectedClmResCat,
            clmResCatDesc: this.selectedClmResCatDesc,
            settCode: 'N',
            rcvrPi: false,
            clmPaytType: null,
            isSuppGstreg: false,
            theirTaxInv: null,
            dvInvDate: this.tranDate,
            pastReversal: false,
            paytAmt: formatDisplayNumber(0, 2),
            paytAmtLoc: formatDisplayNumber(0, 2),
            paytAmtTax: formatDisplayNumber(0, 2),
            paytAmtTaxLoc: formatDisplayNumber(0, 2),
            gstStat: null,
            gstStatDesc: null,
            gstRate: this.gstRate,
            gstAmt: formatDisplayNumber(0, 2),
            gstAmtLoc: formatDisplayNumber(0, 2),
            netAmt: formatDisplayNumber(0, 2),
            netAmtLoc: formatDisplayNumber(0, 2),
            prtOffSettLtr: 'N',
            prtClmDv: 'N',
            bankAcctCurr: null,
            bankChrgLoc: formatDisplayNumber(0, 2),
            clmResLocOS: reserve.clmResLocOS,
            clmResOS: reserve.clmResOS,
            paid: reserve.paid,
            planned: reserve.planned,
            totRes: reserve.totRes,
            bankChrg: formatDisplayNumber(0, 2),
            bankRate: formatDisplayNumber(0, 2),
            tranDate: null,
            curr: this.claimPayHeader.curr,
            exRate: formatDisplayNumber(this.claimPayHeader.exRate, 6),
            paytDet: '',
            tranRel: false,
            finalPayt: false,
            acctMth: null,
            acctYr: null,
            deemGst: this.claimPayHeader.deemGst,
            inOutGst: this.claimPayHeader.inOutGst,
            hClass: 'grey lighten-5',
            readonly: false,
            gstInfo: undefined,
            firstNetAmt: true
          }
          if (!this.claimParams.permitGST) {
            payForm.gstStat = null
            payForm.gstRate = 0
          }
          if (exists) {
            payForm.gstStat = this.claimPayHeader.gstStat
          }
          this.claimPays.push(payForm)
        }
      } else {
        otherClmPays.unshift(relClmPay)
      }
      if (otherClmPays.length > 0) {
        // Review
        for (let clmPay of otherClmPays) {
          const filterGstRate = this.gstRates.filter(item => item['value'] === clmPay.gstStat && item['rate'] === clmPay.gstRate)
          let gstInfo = filterGstRate[0].label + ' - ' + filterGstRate[0].date + ' - ' + filterGstRate[0].rate
          this.gstRate = clmPay.gstRate
          this.gstInfo = gstInfo
          const payForm = {
            clmNo: clmPay.clmNo,
            clmtNo: clmPay.clmtNo,
            clmItem: clmPay.clmItem,
            clmResCat: clmPay.clmResCat,
            clmResCatDesc: clmPay.clmResCatDesc,
            paytAmt: this.reverseSign(clmPay.paytAmt, 2),
            paytAmtLoc: this.reverseSign(clmPay.paytAmtLoc, 2),
            gstStat: clmPay.gstStat,
            gstRate: clmPay.gstRate,
            gstAmt: this.reverseSign(clmPay.gstAmt, 2),
            gstAmtLoc: this.reverseSign(clmPay.gstAmtLoc, 2),
            clmPaytType: clmPay.clmPaytType,
            paytDet: clmPay.paytDet,
            bankAcctCurr: clmPay.bankAcctCurr,
            bankChrg: this.reverseSign(formatDisplayNumber(clmPay.bankChrg, 2), 2),
            bankChrgLoc: this.reverseSign(clmPay.bankChrgLoc, 2),
            tranRel: clmPay.tranRel,
            finalPayt: clmPay.finalPayt,
            yourRef: clmPay.yourRef,
            theirTaxInv: clmPay.theirTaxInv,
            acctMth: clmPay.acctMth,
            acctYr: clmPay.acctYr,
            settCode: clmPay.settCode,
            inOutGst: this.claimPayHeader.inOutGst,
            deemGst: clmPay.deemGst,
            isSuppGstreg: clmPay.isSuppGstreg,
            paytAmtTax: this.reverseSign(clmPay.paytAmtTax, 2),
            paytAmtTaxLoc: this.reverseSign(clmPay.paytAmtTaxLoc, 2),
            prtOffSettLtr: clmPay.prtOffSettLtr,
            prtClmDv: clmPay.prtClmDv,
            offSettLtrPrtd: clmPay.offSettLtrPrtd,
            clmDvprtd: clmPay.clmDvprtd,
            rcvrPi: clmPay.rcvrPi,
            dvInvDate: clmPay.dvInvDate,
            pastReversal: clmPay.pastReversal,
            netAmt: this.reverseSign(clmPay.netAmt, 2),
            netAmtLoc: this.reverseSign(clmPay.netAmtLoc, 2),
            paytAmtRes: this.reverseSign(clmPay.paytAmtRes, 2),
            curr: clmPay.curr,
            exRate: formatDisplayNumber(clmPay.exRate, 6),
            readonly: clmPay.readonly,
            hClass: clmPay.hClass,
            bankChrgRes: this.reverseSign(clmPay.bankChrgRes, 2),
            gstInfo: gstInfo,
            firstNetAmt: false
          }
          // if (!this.claimParams.permitGST) {
          //   payForm.gstStat = null
          //   payForm.gstRate = formatDisplayNumber(0, 2)
          // }
          this.claimPays.push(payForm)
        }
      }
      this.claimPays[0].gstInfo = this.gstInfo
      this.claimPays[0].gstRate = this.gstRate
      if (this.claimPays.length > 1) {
        this.checkClmPayt = true
      }
      await this.fetchCurrRates().then(() => {
        this.recalculate()
      })
    },
    initBankInfo() {
      this.claimPayHeader.cheque = null
      this.claimPayHeader.payChqNo = null
      this.bankChrgResCurr = null
      this.claimPays.map(el => {
        el.bankChrg = formatDisplayNumber(0, 2)
        el.bankChrgLoc = formatDisplayNumber(0, 2)
        el.bankChrgRes = formatDisplayNumber(0, 2)
      })
    },
    payToChanged() {
      this.payInsdChanged()
      this.claimPayHeader.payInsd = this.claimPayHeader.payTo === 'insured'
      // this.claimPayHeader.acctNoSfx = ''
      // this.acctNoSfxDesc = ''
      this.$validator.reset()
    },
    payInsdChanged() {
      this.claimPayHeader.payeeAcctNo = undefined
      this.claimPayHeader.titleName = undefined
      this.claimPayHeader.postCode = undefined
      this.claimPayHeader.addr1 = undefined
      this.claimPayHeader.addr2 = undefined
      this.claimPayHeader.addr3 = undefined
      this.claimPayHeader.addr4 = undefined
      this.claimPayHeader.name = undefined
      this.claimPayHeader.name2 = undefined
    },
    async fetchClmRiRcvy() {
      const expand = {
        clmNo: this.commonInfo.clmNo,
        clmtNo: this.selectedClaimant.clmtNo,
        clmItem: this.selectedClmItem.clmItem,
        clmResCat: this.paymentReserves[0].clmResCat,
        orgTranType1: this.claimPayHeader.tranType1,
        orgDocNo: this.claimPaymentHeader.docNo
      }
      const apiUrl = this.claimDetail.menu.getTop1ClmRiRcvy
      if (apiUrl) {
        try {
          const response = await this.$http.get(expandURI(apiUrl, expand))
          const { data } = response.data
          this.prevClmRiRcvyCurr = data.rcvyCurr
        } catch {}
      }
    },
    async fetchInsured() {
      this.payeeValid = true
      this.claimPayHeader.titleName = undefined
      this.claimPayHeader.postCode = undefined
      this.claimPayHeader.addr1 = undefined
      this.claimPayHeader.addr2 = undefined
      this.claimPayHeader.addr3 = undefined
      this.claimPayHeader.addr4 = undefined
      this.claimPayHeader.name = undefined
      this.claimPayHeader.name2 = undefined
      const apiUrl = this.claimDetail.menu.insured
      if (apiUrl) {
        try {
          if (this.claimPayHeader.payeeAcctNo) {
            this.payeeAcctNoLoading = true
            const result = await this.$http.get(
              expandURI(apiUrl, { payInsd: this.claimPayHeader.payInsd, payeeAcctNo: this.claimPayHeader.payeeAcctNo })
            )
            const { data } = result.data
            if (data) {
              this.payeeAcctNoLoading = false
              this.claimPayHeader.titleName = data.titleName
              this.claimPayHeader.postCode = data.postCode
              this.claimPayHeader.addr1 = data.addr1
              this.claimPayHeader.addr2 = data.addr2
              this.claimPayHeader.addr3 = data.addr3
              this.claimPayHeader.addr4 = data.addr4
              this.claimPayHeader.name = data.name
              this.claimPayHeader.name2 = data.name2
              this.$validator.validate('payeeAcctNo')
            } else {
              this.$toast.warning('Payee not found.')
              this.claimPayHeader.titleName = undefined
              this.claimPayHeader.postCode = undefined
              this.claimPayHeader.addr1 = undefined
              this.claimPayHeader.addr2 = undefined
              this.claimPayHeader.addr3 = undefined
              this.claimPayHeader.addr4 = undefined
              this.claimPayHeader.name = undefined
              this.claimPayHeader.name2 = undefined
              this.payeeValid = false
              this.$validator.validate('payeeAcctNo')
            }
          } else {
            this.claimPayHeader.titleName = undefined
            this.claimPayHeader.postCode = undefined
            this.claimPayHeader.addr1 = undefined
            this.claimPayHeader.addr2 = undefined
            this.claimPayHeader.addr3 = undefined
            this.claimPayHeader.addr4 = undefined
            this.claimPayHeader.name = undefined
            this.claimPayHeader.name2 = undefined
            this.payeeValid = true
            this.$validator.validate('payeeAcctNo')
          }
        } catch (err) {
          this.payeeValid = false
          this.$validator.validate('payeeAcctNo')
          const { data } = err.response
          if (data) {
            this.message(data)
          }
        }
      } else {
        this.errorMessage('The request failed because it is trying to execute an invalid API url.')
      }
      this.payeeAcctNoLoading = false
    },
    getCurrRate(curr) {
      return this.getItemValue(curr, this.currencyList).currRate
    },
    async fetchCurrRates() {
      const apiUrl = this.claimDetail.menu.currRates
      if (apiUrl) {
        const expand = {
          effDate: (this.claimPayHeader.tranDate || new Date()).getTime()
        }
        const result = await this.$http.get(expandURI(apiUrl, expand))
        const { data } = result.data
        this.currencyList = []
        if (data) {
          data.map(param => {
            const currItem = {
              label: param.curr + ' - ' + param.currDesc,
              value: param.curr,
              currRate: param.currRate
            }
            this.currencyList.push(currItem)
          })
        }
      } else {
        this.errorMessage('The request failed because it is trying to execute an invalid API url.')
      }
    },
    async fetchGstRates() {
      const apiUrl = this.claimDetail.menu.gstRates
      if (apiUrl) {
        try {
          this.gstRates = []
          const result = await this.$http.get(apiUrl)
          const { data } = result.data
          if (data) {
            data.map(element => {
              const obj = {
                label: element.label,
                value: element.value,
                rate: element.secondaryValue,
                date: element.thirdValue,
                secondaryValue: element.fourthValue
              }
              this.gstRates.push(obj)
            })
          }
        } catch (err) {
          this.gstRates = []
          const { data } = err.response
          if (data) {
            this.message(data)
          }
        }
      } else {
        this.errorMessage('The request failed because it is trying to execute an invalid API url.')
      }
    },
    fetchGstRates2(gstStat) {
      this.gstRates2 = clone(this.gstRates)
      this.gstRates2 = this.getItemValueList2(gstStat, this.gstRates2)
    },
    async recalculate(claimPay) {
      if (claimPay !== null && claimPay !== '' && claimPay !== undefined) {
        this.selectGstStatDesc = claimPay
      }
      this.claimPays[0].gstStatDesc = this.selectGstStatDesc == null ? '' : this.selectGstStatDesc
      // this.claimPays[0].gstStatDesc = claimPay == null ? '' : this.claimPays[0].gstStat.substring(0, 1)
      const apiUrl = this.claimDetail.menu.getRecalculate
      if (this.claimPays[0].gstStat != null) {
        this.fetchGstRates2(this.claimPays[0].gstStat)
      }
      if (apiUrl) {
        this.totAmt = 0
        this.totAmtLoc = 0
        this.totAmtTax = 0
        this.totAmtTaxLoc = 0
        try {
          let calcParam = []
          const relClmPay = this.claimPays[0]
          let gstRate = 0
          let gstDit = false

          // if (!isEmptyOrWhiteSpace(relClmPay.gstStat)) {
          //   // gstRate = this.getItemSecondValue(relClmPay.gstStatDesc, this.gstRates2[0]).rate
          //   if (!this.checkClmPayt) {
          //     const filterGstRate = this.gstRates2.filter(item => item['secondaryValue'] === claimPay)
          //     relClmPay.gstRate = filterGstRate[0].rate
          //   }
          // } else {
          //   relClmPay.gstRate = 0
          // }
          if (!isEmptyOrWhiteSpace(relClmPay.clmPaytType)) {
            gstDit = this.getItemValue(relClmPay.clmPaytType, this.paymentTypes).gstInc
          }
          const paytData = {
            clmResCat: relClmPay.clmResCat,
            paytAmt: removeFormatNumber(relClmPay.paytAmt) || 0.0,
            paytAmtTax: removeFormatNumber(relClmPay.paytAmtTax) || 0.0,
            netAmt: removeFormatNumber(relClmPay.netAmt) || 0.0,
            gstRate: gstRate,
            bankChrg: removeFormatNumber(relClmPay.bankChrg),
            gstDit: gstDit,
            bankRate: this.getCurrRate(this.claimPayHeader.bankAcctCurr),
            curr: relClmPay.curr,
            exRate: relClmPay.exRate
          }
          calcParam.push(paytData)
          for (let claimPay of this.claimPays) {
            claimPay.paytAmt = removeFormatNumber(claimPay.paytAmt) || 0.0
            claimPay.paytAmtTax = removeFormatNumber(claimPay.paytAmtTax) || 0.0
            claimPay.netAmt = removeFormatNumber(claimPay.netAmt) || 0.0
            claimPay.bankChrg = removeFormatNumber(claimPay.bankChrg) || 0.0
          }

          const payment = {
            tranType1: this.claimPayHeader.tranType1,
            branch: this.commonInfo.branch,
            fund: this.commonInfo.fund,
            docNo: this.claimPaymentHeader.docNo,
            clmNo: this.commonInfo.clmNo,
            clmtNo: this.selectedClaimant.clmtNo,
            clmItem: this.selectedClmItem.clmItem,
            clmResCat: this.paymentReserves[0].clmResCat,
            deemGst: this.claimPayHeader.deemGst,
            tranDate: this.claimPayHeader.tranDate,
            gstStat: this.claimPays.gstStat,
            pays: this.claimPays
          }
          const result = await this.$http.post(apiUrl, payment)
          const data = result.data
          if (data) {
            const payItem = data.payItems
            this.totAmt = data.totAmt
            this.totAmtLoc = data.totAmtLoc
            this.totAmtTax = data.totAmtTax
            this.totAmtTaxLoc = data.totAmtTaxLoc
            relClmPay.gstAmt = formatDisplayNumber(payItem[relClmPay.clmResCat].gstAmt, 2)
            relClmPay.gstAmtLoc = formatDisplayNumber(payItem[relClmPay.clmResCat].gstAmtLoc, 2)
            relClmPay.netAmt = formatDisplayNumber(payItem[relClmPay.clmResCat].netAmt, 2)
            relClmPay.netAmtLoc = formatDisplayNumber(payItem[relClmPay.clmResCat].netAmtLoc, 2)
            relClmPay.paytAmt = formatDisplayNumber(payItem[relClmPay.clmResCat].paytAmt, 2)
            relClmPay.paytAmtLoc = formatDisplayNumber(payItem[relClmPay.clmResCat].paytAmtLoc, 2)
            relClmPay.paytAmtRes = formatDisplayNumber(payItem[relClmPay.clmResCat].paytAmtRes, 2)
            relClmPay.paytAmtTax = formatDisplayNumber(payItem[relClmPay.clmResCat].paytAmtTax, 2)
            relClmPay.paytAmtTaxLoc = formatDisplayNumber(payItem[relClmPay.clmResCat].paytAmtTaxLoc, 2)
            relClmPay.bankChrgLoc = formatDisplayNumber(payItem[relClmPay.clmResCat].bankChrgLoc, 2)
            relClmPay.bankChrgRes = formatDisplayNumber(payItem[relClmPay.clmResCat].bankChrgRes, 2)
          }
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
          }
        }
      } else {
        this.errorMessage('The request failed because it is trying to execute an invalid API url.')
      }
    },
    adjustCurr(claimPay) {
      if (!isEmptyOrWhiteSpace(claimPay.curr)) {
        claimPay.exRate = formatDisplayNumber(this.getCurrRate(claimPay.curr), 6)
      } else {
        claimPay.exRate = formatDisplayNumber(0, 6)
      }
      this.selectedCurrency = claimPay.curr
      this.recalculate()
    },
    adjustBank(key) {
      if (!isEmptyOrWhiteSpace(key)) {
        this.claimPayHeader.bankAcctCurr = this.getItemValue(key, this.claimParams.bankList).secondaryValue
        this.bankChrgResCurr = this.getItemValue(key, this.claimParams.bankList).secondaryValue
        this.bankBalance = formatDisplayNumber(this.getItemValue(key, this.claimParams.bankList).thirdValue)
      } else {
        this.claimPayHeader.bankAcctCurr = undefined
        this.bankBalance = formatDisplayNumber(0, 2)
      }
      this.recalculate()
    },
    async doFetchAddress() {
      const apiUrl = this.$store.state.claims.claimDetail.menu.address
      if (apiUrl) {
        try {
          this.appPostalCodeLoading = true
          const expand = {
            postCode: this.claimPayHeader.postCode
          }
          const result = await this.$http.get(expandURI(apiUrl, expand))
          const { data } = result
          if (data) {
            this.claimPayHeader.addr1 = data.add1
            this.claimPayHeader.addr2 = data.add2
            this.claimPayHeader.addr4 = data.add4
            this.addrFound = true
          }
          this.appPostalCodeLoading = false
        } catch (err) {
          this.addrFound = false
          this.appPostalCodeLoading = false
          const { data } = err.response
          if (data) {
            if (!isEmptyOrWhiteSpace(this.claimPayHeader.postCode)) {
              this.notify(data)
            } else {
              this.$toast.warning('Postal Code not found. Please key in full address instead.')
            }
          }
        }
      } else {
        this.addrFound = false
        this.$toast.error('The request failed because it is trying to execute an invalid API url.')
      }
    },
    getClaimantName(clmtNo) {
      for (let claimant of this.commonInfo.claimants) {
        if (claimant.clmtNo === clmtNo) {
          return claimant.clmtName
        }
      }
      return ''
    },
    getParamReserve(key) {
      for (let paramReserve of this.reserveList) {
        if (paramReserve.value === key) {
          return paramReserve
        }
      }
      return {}
    },
    getItemRate(key, arrayList) {
      for (let param of arrayList) {
        if (param.rate === key) {
          return param
        }
      }
      return {}
    },
    formatDisplayNumber(val, scale) {
      return formatDisplayNumber(val, scale)
    },
    removeFormatNumber(val) {
      return removeFormatNumber(val)
    },
    reverseSign(val, scale) {
      if (this.claimPayHeader.tranType1 === 'W' || this.claimPayHeader.tranType1 === 'Y') {
        return formatDisplayNumber(val * -1, scale)
      } else {
        return formatDisplayNumber(val, scale)
      }
    },
    genDocNo() {
      if (this.autoDocNo && this.claimPayment.newHeader) {
        this.claimPayHeader.docNo = undefined
        this.$validator.reset()
      }
    },
    doModalAction() {
      this.initBankInfo()
    },
    doAssign(obj) {
      this.claimPayHeader.bankNo = obj.label
      this.claimPayHeader.bankAcctCurr = obj.secondaryValue
      this.bankChrgResCurr = obj.secondaryValue
      this.bankBalance = formatDisplayNumber(obj.thirdValue)
    },
    checkClosedClaim() {
      if (this.claimPayHeader.clmClsd === false) {
        this.claimPayHeader.cseStat = ''
      }
    }
  },
  mounted() {
    this.init()
    // this.initClmPayForm()
  },
  created() {
    this.$validator.extend('validatePayee', {
      getMessage(field, args) {
        return 'Payee is not found.'
      },
      validate(value, args) {
        return args[0]
      }
    })
    this.$validator.extend('validPaytAmtTax', {
      getMessage(field, args) {
        return `The ${field} cannot be greater than Claim Payment.`
      },
      validate(paytAmtTax, args) {
        if (paytAmtTax) {
          var paytAmt = args[0]
          if (Number(removeFormatNumber(paytAmt)) < Number(removeFormatNumber(paytAmtTax))) {
            return false
          }
        }
        return true
      }
    })
    // this.$validator.extend('validatePaytCurr', {
    //   getMessage(field, args) {
    //     return 'Must be Base Currency if Bank Charges Currency is not equal to Payment Currency'
    //   },
    //   validate(value, args) {
    //     const baseCurr = args[0]
    //     const riRcyCurr = args[1]
    //     const bankChrgCurr = args[2]
    //     const curr = args[3]
    //     if (baseCurr !== riRcyCurr) {
    //       if (bankChrgCurr !== null && bankChrgCurr !== '' && curr !== bankChrgCurr) {
    //         return false
    //       }
    //     }
    //     return true
    //   }
    // })
    this.$validator.extend('validateBankChrg', {
      getMessage(field, args) {
        return 'Please enter Bank No or Bank Charge will be zerorised.'
      },
      validate(value, args) {
        const bankChrg = args[0]
        if (!bankChrg && value > 0) {
          return false
        }
        return true
      }
    })
    this.$validator.extend('validateBaseCurr', {
      getMessage(field, args) {
        return 'Must be Payment or Base Currency'
      },
      validate(value, args) {
        const riRcyCurr = args[1]
        const curr = args[3]
        if (curr !== riRcyCurr) {
          return false
        } else return true
      }
    })
    this.$validator.extend('validateclmRiRcvyCurr', {
      getMessage(field, args) {
        return 'Must be ' + args[1] + ', same as previous recoveries on this transaction.'
      },
      validate(value, args) {
        const prevRiClmRcvy = args[0]
        const currRiRcvy = args[1]
        if (prevRiClmRcvy !== null && currRiRcvy !== prevRiClmRcvy) {
          return false
        } else return true
      }
    })
  },
  mixins: [ClaimCommonMixin, MessageMixin, commonAjaxMixin]
}
</script>

<style>
.display-inline {
  display: inline-block;
}
</style>
